module.exports = "/_next/static/images/boon-logo-e1c3b507bbebc4089fbaebee9b3b5ed1.png";